<!-- contact us路由组件 -->
<template>
  <el-container class="dashboard_box pt-2">
    <el-container>
      <el-aside class="left-nav">
        <leftNav></leftNav>
      </el-aside>
      <el-main class="child-el-main ps-4">
        <el-row class="justify-content-start align-items-center">
          <breadcrumb class="breadcrumb-container breadcrumb-box" />
        </el-row>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup name="DashboardLayout">
import { isEmpty, isNotEmpty } from '@/utils/index'
import leftNav from './leftNav.vue'
import breadcrumb from '@/components/Breadcrumb'

</script>

<style scoped lang="scss">
.left-nav {
  width: 250px !important;
}

.dashboard_box {
  overflow-x: auto;
}

@media screen and (max-width: 992px) {

  .left-nav {
    width: 70px !important;
  }
}


.breadcrumb-box {
  line-height: unset !important;
}

.child-el-main {
  padding: 0;
  padding-left: 0.625rem;
}
</style>
